import { isLocalParticipantModerator, isParticipantModerator } from "../base/participants/functions";
const getState = (state) => state['features/vt-file-upload-moderation'];
// Check if file upload moderation is enabled
export const isEnableBanAllUpload = (state) => !!getState(state)?.enabled;
// Get file by ID from the state
export const getFile = (state, id) => getState(state)?.files.find((f) => f.id === id);
// Check if the local participant can upload files
export const isLocalParticipantCanUpload = (state) => {
    if (isLocalParticipantModerator(state)) {
        return true;
    }
    const { canUpload } = getState(state);
    if (canUpload !== undefined) {
        return canUpload;
    }
    return !isEnableBanAllUpload(state);
};
// Check if a participant is approved to upload files
export const isParticipantApprovedUpload = (participantId, state) => !!getState(state)?.whitelist[participantId];
// Check if a participant is rejected for file uploads
export const isParticipantRejectedUpload = (participantId, state) => !!getState(state)?.blacklist[participantId];
// Check if a participant is banned from uploading files
export function isBannedUpload(participant, state) {
    if (participant.local) {
        return !isLocalParticipantCanUpload(state);
    }
    // Moderators cannot be banned from uploading files
    if (isParticipantModerator(participant)) {
        return false;
    }
    if (isEnableBanAllUpload(state)) {
        return !isParticipantApprovedUpload(participant.id, state);
    }
    return Boolean(isParticipantRejectedUpload(participant.id, state));
}
